import gql from "graphql-tag";

export const CREATE_SOURCE = gql`
  mutation AddSource($data: SourceDataInput) {
    addSource(data: $data) {
      id
    }
  }
`;

export const UPDATE_SOURCE = gql`
  mutation UpdateSource($data: SourceDataInput, $where: SourceWhereInput) {
    updateSource(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_SOURCE = gql`
  mutation DeleteSource($where: SourceWhereInput) {
    deleteSource(where: $where) {
      id
    }
  }
`;

export const REPLAY_LEAD_TYPOLOGIES = gql`
  mutation ReplayLeadTypologies($sourceId: ID!) {
    replayLeadTypologies(sourceId: $sourceId) {
      updated
    }
  }
`;

export const STOP_SOURCE = gql`
  mutation StopSource($where: SourceWhereInput!) {
    stopSource(where: $where) {
      id
      archivedAt
      status
    }
  }
`;

export const START_SOURCE = gql`
  mutation StartSource($where: SourceWhereInput!) {
    startSource(where: $where) {
      id
      archivedAt
      status
    }
  }
`;

export const UPDATE_PROJECT_SOURCE = gql`
  mutation UpdateProjectSource(
    $where: ProjectWhereInput!
    $data: ProjectSourceDataInput!
  ) {
    updateProjectSource(where: $where, data: $data) {
      id
      source {
        id
        name
      }
    }
  }
`;

const sources = {
  CREATE_SOURCE,
  UPDATE_SOURCE,
  DELETE_SOURCE,
  REPLAY_LEAD_TYPOLOGIES,
  STOP_SOURCE,
  START_SOURCE,
  UPDATE_PROJECT_SOURCE,
};

export default sources;
